import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { CopyText } from 'components';
import { TranslationNamespace } from 'i18n';
import { OrderAutomation } from 'types';

type Props = { orderAutomation: OrderAutomation };

export const OrderAutomationSummary: React.FC<Props> = ({
  orderAutomation,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.order_automation.table.columns',
  });
  return (
    <Fragment>
      <div className="tw-mb-2">
        <div className="tw-font-bold">{`${t('id')}:`}</div>
        <div>
          <CopyText text={orderAutomation.id} />
        </div>
      </div>
      <div className="tw-mb-4">
        <div className="tw-font-bold">{`${t('text')}:`}</div>
        <div>
          <CopyText text={orderAutomation.text} />
        </div>
      </div>
    </Fragment>
  );
};
